import React, { useState } from 'react';
import { ArrowUpRight, ChevronDown, ChevronUp } from 'lucide-react';

export function TransactionsTable({ transactions }) {
  const [showTransactions, setShowTransactions] = useState(false);

  if (!transactions || transactions.length === 0) return null;

  return (
    <div className="card-surface p-6" data-testid="recent-transactions">
      <button
        onClick={() => setShowTransactions(!showTransactions)}
        className="w-full flex items-center justify-between text-sm font-medium text-[#1A1A1A]"
        data-testid="toggle-transactions-btn"
      >
        <span className="flex items-center gap-2">
          <ArrowUpRight className="h-4 w-4 text-[#D4AF37]" />
          Recent Transactions ({transactions.length})
        </span>
        {showTransactions ? (
          <ChevronUp className="h-4 w-4 text-stone-400" />
        ) : (
          <ChevronDown className="h-4 w-4 text-stone-400" />
        )}
      </button>
      
      {showTransactions && (
        <div className="mt-4 overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-[#E6E4DD]">
                <th className="text-left py-2 px-3 text-stone-500 font-medium">Date</th>
                <th className="text-left py-2 px-3 text-stone-500 font-medium">Booking</th>
                <th className="text-right py-2 px-3 text-stone-500 font-medium">Gross</th>
                <th className="text-right py-2 px-3 text-stone-500 font-medium">Fees</th>
                <th className="text-right py-2 px-3 text-stone-500 font-medium">You Earn</th>
                <th className="text-left py-2 px-3 text-stone-500 font-medium">Status</th>
              </tr>
            </thead>
            <tbody>
              {transactions.map((txn) => (
                <tr key={txn.transaction_id} className="border-b border-[#E6E4DD] hover:bg-[#F9F6F0]">
                  <td className="py-3 px-3 text-stone-600">
                    {txn.created_at ? new Date(txn.created_at).toLocaleDateString('en-GB', {day: 'numeric', month: 'short'}) : '-'}
                  </td>
                  <td className="py-3 px-3 text-stone-600 font-mono text-xs">{txn.booking_id}</td>
                  <td className="py-3 px-3 text-right text-stone-600">£{txn.amount.toFixed(2)}</td>
                  <td className="py-3 px-3 text-right text-red-500 text-xs">
                    -£{(txn.commission + txn.processing_fee).toFixed(2)}
                  </td>
                  <td className="py-3 px-3 text-right font-medium text-emerald-600">£{txn.provider_amount.toFixed(2)}</td>
                  <td className="py-3 px-3">
                    <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${
                      txn.status === 'available' 
                        ? 'bg-emerald-100 text-emerald-700' 
                        : 'bg-amber-100 text-amber-700'
                    }`}>
                      {txn.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
